{
  "steps": {
    "availability": "Product available at your distributor",
    "customerReturn": "Return transport to your site"
  },
  "title": "Your next actions",
  "nextAction": "YOUR NEXT ACTION: {action}",
  "pastAction": "ACTION AT THIS STEP: {action}",
  "noValue": "Not provided",
  "remindersActive": "Automatic reminders enabled.",
  "options": {
    "OPTION_1": "Repair package",
    "OPTION_2": "Diagnosis and estimate",
    "OPTION_3": "Recycling",
    "CREDIT_OR_REFUND": "Credit / refund",
    "PRODUCT_REPLACEMENT": "Replacement with a new product",
    "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Product return requested for diagnosis",
    "PRODUCT_REPAIR_WITH_GUARANTEE": "Repair under warranty",
    "TECHNICIAN_ON_SITE_INTERVENTION": "On-site technician intervention",
    "REJECT_PROSPECT": "Support request rejected",
    "OTHER": "Other",
    "DIAGNOSIS": "Diagnosis and estimate",
    "ON_SITE": "On-site technician intervention"
  },
  "events": {
    "PRELIMINARY_RESPONSE_RECEIVED": "REPAIRER RESPONSE RECEIVED: {option}. Resume the file to confirm how to proceed.",
    "PRELIMINARY_RESPONSE_DECLARED": "REPAIRER RESPONSE RECORDED: {option}.",
    "PRELIMINARY_INFORMATION_RECEIVED": "ADDITIONAL REPAIRER INFORMATION RECORDED. Support number: {request_number}. Comment: {comment}",
    "FILE_CLOSED_DECLARED": "12. FILE MANUALLY CLOSED.",
    "CUSTOMER_AVAILABILITY_DECLARED": "11a. YOUR DISTRIBUTOR DECLARED HAVING NOTIFIED YOU OF PRODUCT AVAILABILITY at {depot}.",
    "CUSTOMER_DECISION_FORWARDED_TO_STORE": "7. YOUR DECISION HAS BEEN FORWARDED TO YOUR DISTRIBUTOR: {option}. They will continue discussions with the repairer.",
    "BREAKDOWN_REPORTED": "ISSUE REPORTED: {description}.",
    "FILE_CREATION_STARTED": "1. FILE CREATION IN PROGRESS. Your distributor is arranging service for your product.",
    "PACKAGE_PROPOSAL_SENT": "PACKAGE PROPOSAL SENT. Your distributor is awaiting your choice since {date}.",
    "PACKAGE_DECISION_RECEIVED": "YOUR CHOICE HAS BEEN RECORDED: {option}. Your distributor will continue servicing your product.",
    "PRELIMINARY_REQUEST_SENT": "SERVICE REQUEST SENT TO REPAIRER. Your distributor is awaiting their response before continuing.",
    "TRANSPORT_LABELS_REQUESTED": "TRANSPORT ARRANGEMENTS IN PROGRESS. Labels have been requested from the transport partner.",
    "OUTBOUND_TRANSPORT_STARTED": "2. OUTBOUND TRANSPORT INITIATED. Transport to the repairer has been arranged since {date}.",
    "REPAIRER_RECEIPT_RECORDED": "3. PRODUCT RECEIVED BY REPAIRER. Awaiting diagnosis since {date}.",
    "CUSTOMER_ESTIMATE_SENT": "6. ESTIMATE SENT. Your distributor is awaiting your decision.",
    "CUSTOMER_ESTIMATE_SEND_DECLARED": "6. ESTIMATE PROVIDED BY YOUR DISTRIBUTOR. Your distributor is awaiting your decision.",
    "CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. YOUR DECISION HAS BEEN SENT TO THE REPAIRER: {option}. Awaiting processing by the repairer.",
    "CUSTOMER_DECISION_SEND_DECLARED": "7. DECISION SENT TO REPAIRER BY YOUR DISTRIBUTOR: {option}.",
    "CUSTOMER_DECISION_TRANSMISSION_UNVERIFIED": "7. YOUR DECISION TRANSMISSION HAS BEEN DECLARED. No message was sent to the repairer by the platform.",
    "REPAIR_STARTED": "8. REPAIR IN PROGRESS AT THE REPAIRER since {date}.",
    "REPAIR_PARTS_ORDERED": "8. PARTS ORDERED. The repairer is awaiting parts to continue the repair since {date}.",
    "REPAIRER_RETURN_STARTED": "9. RETURN TRANSPORT INITIATED BY REPAIRER. Your product will be sent to {destination}.",
    "NO_RETURN_TREATMENT_FINALIZED": "9. TREATMENT FINALIZED BY REPAIRER: {option}. Your distributor will finalize the file.",
    "CUSTOMER_AVAILABILITY_NOTIFIED": "11a. YOUR PRODUCT IS AVAILABLE AT {depot}.",
    "CUSTOMER_RETURN_DISPATCHED": "11b. RETURN TRANSPORT TO YOUR SITE INITIATED.",
    "FILE_CLOSED_WITH_RETURN": "12. HANDOVER / RECEIPT DECLARED — FILE CLOSED. Outcome: {option}.",
    "FILE_CLOSED_WITHOUT_RETURN": "12. FILE CLOSED. The requested treatment has been finalized: {option}.",
    "BILLING_STAGE_ENTERED": "13. BILLING. Billing processing is in progress.",
    "FILE_FINISHED": "14. FILE FINISHED. Service for your product has been finalized.",
    "PACKAGE_PROPOSAL_QUEUED": "Your distributor is preparing a package proposal.",
    "PRELIMINARY_REQUEST_QUEUED": "Your distributor is preparing a request to the repairer.",
    "CUSTOMER_DECISION_QUEUED": "Your decision has been recorded: {option}. Transmission to the repairer is pending.",
    "CUSTOMER_RETURN_DELIVERED": "The carrier reports delivery to your site on {date}.",
    "CUSTOMER_RECEIPT_SMS_SENT": "Product receipt confirmation SMS sent to {phone} on {date}.",
    "CUSTOMER_RECEIPT_CONFIRMED": "You confirmed product receipt on {date}. Attached photo: Returned product customer photo. Comment: {comment}",
    "FILE_ABANDONED": "File abandoned.",
    "FILE_DELETED": "File deleted."
  },
  "actions": {
    "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "Resume the file to confirm the repairer's response and arrange transport if required.",
    "RESPOND_TO_PACKAGE_PROPOSAL": "Reply to the email to choose how to proceed with service.",
    "RESPOND_TO_CUSTOMER_ESTIMATE": "Reply to the estimate email to choose how to proceed.",
    "RESPOND_TO_DISTRIBUTOR_ESTIMATE": "Reply to your distributor using the instructions provided with the estimate.",
    "DESCRIBE_DIRECT_DECISION_TRANSMISSION": "If you sent your decision directly, specify the choice and date in a comment.",
    "ARRANGE_PRODUCT_COLLECTION": "Arrange product collection with your distributor.",
    "CONFIRM_PRODUCT_RECEIPT": "Confirm product receipt in the file once delivered."
  }
}
